export let GET_KQ_URL: string;
export let POST_KQ_URL: string;
export let POST_SUBSCRIBE_OFFER_URL: string;
export let POST_USER_ACT_CAND_URL: string;
export let OFFER_ID: string;
export let CURRENT_URL: string;
export let LOGIN_URL: string;
export let LOGIN_BLOCK_MAX_TRIES: number;
export let LOGIN_BLOCK_MINUTES: number;
export let LOGIN_BLOCK_TRIES_COOKIE_NAME: string;
export let LOGIN_BLOCK_MINUTES_COOKIE_NAME: string;
export let GET_HAVE_EXPERIENCE_URL: string;
export let GET_SECTORS_URL: string;
export let GET_OCUPATION_URL: string;
export let SET_EXPERIENCE_URL: string;
export let SET_HAVE_NO_EXPERIENCE_URL: string;
export let GET_HAS_REGULATED_TRAINING: string;
export let GET_STUDIES_DEGREES_URL: string;
export let GET_STUDIES_URL: string;
export let SET_FORMATION_URL: string;
export let SET_HAVE_NO_REGULATED_TRAINING_URL: string;
export let NEW_EXPERIENCE_TOAST: string;
export let NEW_FORMATION_TOAST: string;

$(() => {
  const settingsElement = $("#offerDetailSettings");
  GET_KQ_URL = settingsElement.attr("data-GET_KQ_URL")!;
  POST_KQ_URL = settingsElement.attr("data-POST_KQ_URL")!;
  POST_SUBSCRIBE_OFFER_URL = settingsElement.attr(
    "data-POST_SUBSCRIBE_OFFER_URL"
  )!;
  POST_USER_ACT_CAND_URL = settingsElement.attr(
    "data-POST_USER_ACT_CAND_URL"
  )!;
  OFFER_ID = settingsElement.attr("data-OFFER_ID")!;
  CURRENT_URL = settingsElement.attr("data-CURRENT_URL")!;
  LOGIN_URL = settingsElement.attr("data-LOGIN_URL")!;

  LOGIN_BLOCK_MAX_TRIES = 4;
  LOGIN_BLOCK_MINUTES = 10;
  LOGIN_BLOCK_TRIES_COOKIE_NAME = "ett-password-block";
  LOGIN_BLOCK_MINUTES_COOKIE_NAME = "ett-password-block-time";
  GET_HAVE_EXPERIENCE_URL = $("#offerDetailSettings").attr("data-GET_HAVE_EXPERIENCE_URL")!;
  GET_SECTORS_URL = $("#offerDetailSettings").attr("data-GET_SECTORS_URL")!;
  GET_OCUPATION_URL = $("#offerDetailSettings").attr("data-GET_OCUPATION_URL")!;
  SET_EXPERIENCE_URL = $("#offerDetailSettings").attr("data-SET_EXPERIENCE_URL")!;
  GET_STUDIES_DEGREES_URL = $("#offerDetailSettings").attr("data-GET_STUDIES_DEGREES_URL")!;
  GET_HAS_REGULATED_TRAINING = $("#offerDetailSettings").attr("data-GET_HAS_REGULATED_TRAINING")!;
  GET_STUDIES_URL = $("#offerDetailSettings").attr("data-GET_STUDIES_URL")!;
  SET_FORMATION_URL = $("#offerDetailSettings").attr("data-SET_FORMATION_URL")!;
  SET_HAVE_NO_EXPERIENCE_URL = $("#offerDetailSettings").attr("data-SET_HAVE_NO_EXPERIENCE_URL")!;
  SET_HAVE_NO_REGULATED_TRAINING_URL = $("#offerDetailSettings").attr("data-SET_HAVE_NO_REGULATED_TRAINING_URL")!;
  NEW_EXPERIENCE_TOAST = $("#offerDetailSettings").attr("data-NEW_EXPERIENCE_TOAST")!;
  NEW_FORMATION_TOAST = $("#offerDetailSettings").attr("data-NEW_FORMATION_TOAST")!;
});
